import React, { useRef } from "react";
import { motion, MotionValue, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { MOMENTS } from "../../data/gallery";
type Moment = (typeof MOMENTS)[number];
function MomentCard({
  moment,
  index,
  total,
  progress
}: {
  moment: Moment;
  index: number;
  total: number;
  progress: MotionValue<number>;
}) {
  const reduce = useReducedMotion();
  const target = 1 - (total - index - 1) * 0.05;
  const scale = useTransform(progress, [index / total, 1], reduce ? [1, 1] : [1, target]);
  const imgScale = useTransform(progress, [index / total, (index + 1) / total], reduce ? [1, 1] : [1.2, 1]);
  return <div className="sticky top-0 flex h-screen items-center justify-center px-5 md:px-9" data-id="element-274" data-mp="320h0xwcoe1f8">
      <motion.article style={{
      scale,
      top: `calc(-6vh + ${index * 26}px)`,
      backgroundColor: moment.tone
    }} className="relative grid h-[76vh] w-full max-w-[1280px] origin-top overflow-hidden text-white md:grid-cols-12" data-id="element-275" data-mp="36tih07omc70e">
        <div className="relative h-[45vh] overflow-hidden md:col-span-7 md:h-full" data-id="element-276" data-mp="35x6llb4948u5">
          <motion.img style={{
          scale: imgScale
        }} src={moment.src} alt={moment.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-277" data-mp="35zaktfr7gjo3" />
        </div>
        <div className="flex flex-col justify-between p-7 md:col-span-5 md:p-12" data-id="element-278" data-mp="2x3l43k0pcdh1">
          <span className="text-sm tabular-nums text-white/50" data-id="element-279" data-mp="2s4qf20c55soh">{String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}</span>
          <div data-id="element-280" data-mp="2n4lwm4roanvm">
            <h3 className="text-4xl font-medium leading-[0.95] tracking-[-0.06em] md:text-6xl" data-id="element-281" data-mp="2i7lolob9jb1v">{moment.title}</h3>
            <p className="mt-5 max-w-sm text-base leading-7 text-white/70" data-id="element-282" data-mp="2e5qscy86vnuy">{moment.copy}</p>
          </div>
        </div>
      </motion.article>
    </div>;
}
export function StackedMoments() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start start", "end end"]
  });
  return <section className="bg-[#fbfaf6] pt-24 md:pt-32" data-id="element-283" data-mp="7g3r3v8rg9bp">
      <div className="mx-auto max-w-[1440px] px-5 md:px-9" data-id="element-284" data-mp="qkfhqsbvvjf0">
        <p className="text-xs font-semibold tracking-[0.18em] text-[#bb1e35]" data-id="element-285" data-mp="qi2txyjg2eu1">MOMENTS THAT MATTER</p>
        <h2 className="mt-5 max-w-3xl text-5xl font-medium leading-[0.92] tracking-[-0.07em] md:text-7xl" data-id="element-286" data-mp="vd0b5sqvnui0">The chapters of an MCC year.</h2>
      </div>
      <div ref={ref} className="relative mt-4" data-id="element-287" data-mp="mhsqasj4k0ic">
        {MOMENTS.map((m, i) => <MomentCard key={m.title} moment={m} index={i} total={MOMENTS.length} progress={scrollYProgress} data-id="element-288" data-mp="1a8g1bmoc7694" data-mpi={i} />)}
      </div>
    </section>;
}